const animationSpeed = 1500;

$(document).ready(() => {
  if (!$('html').hasClass('page-about')) return;

  new Swiper ('[data-founder-swiper],[data-about-swiper]', {
    observer: true,
    slidesPerView: 1.05,
    spaceBetween: 9,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  })

  new Swiper ('[data-about-swiper-desktop]', {
    pagination: {
      el: ".swiper-pagination",
    },
  })

  new Swiper ('[care-guide-swiper]', {
    observer: true,
    slidesPerView: 1,
    spaceBetween: 18,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
  });

  const isMobile = window.innerWidth < 769;
  let wheelCaptured = false;
  let heroSwiper = null;
  let heroNestedSwiper = null;
  const capsules = {
    BLUE: 'blue',
    WHITE: 'white',
    CONCEPT_1: 'concept-1',
    CONCEPT_2: 'concept-2',
    CONCEPT_3: 'concept-3',
    BEADS: 'beads',
    EXPLODED: 'exploded',
    PLASTIC: 'plastic',
  }

  if (!isMobile) {
    heroSwiper = new Swiper('[data-about-hero-swiper]', {
      observer: true,
      centeredSlides: true,
      allowTouchMove: false,
      direction: 'vertical',
      speed: animationSpeed,
      autoHeight: true,
      preventInteractionOnTransition: true,
      mousewheel: false,
      on: {
        init: function () {
          animateCapsule(0)
        },
        slideChange: function () {
          animateCapsule(this.activeIndex)
          captureHero()
        },
      },
    });

    heroNestedSwiper = new Swiper ($('[data-about-hero-swiper-nested]').get(0), {
      observer: true,
      observeParents: true,
      centeredSlides: true,
      allowTouchMove: false,
      direction: 'horizontal',
      nested: true,
      preventInteractionOnTransition: true,
      mousewheel: false,
      effect: 'fade',
      speed: 1000,
      on: {
        slideChange: function () {
          captureHero()
        }
      }
    })
  }

  function getCapsuleByStep(step) {
    return `.about-capsule-container img[data-capsule="${step}"]`
  }
  function showCapsule(step) {
    $('.about-capsule-container img').css('opacity', 0)
    $(getCapsuleByStep(step)).css('opacity', 1)
  }
  function animateCapsule(idx) {
    const lastCapsuleSlideIdx = 10
    const container = $('.about-capsule-container')
    if (idx > lastCapsuleSlideIdx || idx === 0) {
      $('.about-capsule-container img').css('opacity', 0)
      return;
    }
    switch(idx) {
      case 1:
        container.css('width', '')
        container.css('top', '')
        showCapsule(capsules.CONCEPT_1)
        break;
      case 2:
        container.css('width', '85px')
        container.css('top', 'calc(200vh + 50% - 42px)')
        showCapsule(capsules.CONCEPT_1)
        break;
      case 3:
        container.css('width', '210px')
        container.css('top', 'calc(300vh + 50% + 110px)')
        showCapsule(capsules.CONCEPT_1)
        break;
      case 4:
        container.css('width', '200px')
        container.css('top', 'calc(400vh + 29%)')
        showCapsule(capsules.CONCEPT_2)
        break;
      /*
      case 5:
        container.css('top', 'calc(500vh + 35%)')
        container.css('width', '200px')
        showCapsule(capsules.CONCEPT_2)
        break;
      */
      case 5:
        container.css('top', 'calc(500vh + 40%)')
        container.css('width', '220px')
        showCapsule(capsules.PLASTIC)
        break;
      case 6:
        container.css('top', 'calc(600vh + 52%)')
        container.css('width', '220px')
        showCapsule(capsules.PLASTIC)
        break;
      case 7:
        container.css('top', 'calc(700vh + 38.5%)')
        container.css('width', '195px')
        showCapsule(capsules.BEADS)
        break;
      case 8:
        container.css('top', 'calc(800vh + 25%)')
        container.css('width', '195px')
        showCapsule(capsules.EXPLODED)
        break;
      case 9:
        container.css('top', 'calc(900vh + 50% + 27px)')
        container.css('width', '190px')
        showCapsule(capsules.BLUE)
        break;
      case 10:
        container.css('width', '190px')
        container.css('top', 'calc(1000vh - 46.7%)')
        break;
    }
  }
  function sortByIdx(a, b) {
    return a.style.getPropertyValue('--idx') - b.style.getPropertyValue('--idx');
  }
  $('.memberWrapper').click(function(e) {
    const blocks = $(e.currentTarget).find('.member').sort(sortByIdx);
    blocks.each(function(_i, elem) {
      let val = elem.style.getPropertyValue('--idx') - 1
      if(val < 0) val = blocks.length - 1
      elem.style.setProperty('--idx',val)
    })
  })

  function captureHero() {
    wheelCaptured = true;
    $('html, body').animate({
      scrollTop: $('.custom-about-hero-content').offset().top// + window.pageYOffset
    }, 200);
  }

  function releaseHero() {
    wheelCaptured = false;
  }

  function updateCoverPosition() {
    const containerHeight = $('.box-cover').height();
    const top = $('[data-slide="10"] .desktop-only img').offset().top - $('[data-slide="10"]').offset().top;
    const left = $('[data-slide="10"] .desktop-only img').offset().left - $('[data-slide="10"]').offset().left;
    const width = $('[data-slide="10"] .desktop-only img').width();
    const height = $('[data-slide="10"] .desktop-only img').height();

    $('.box-cover img')
      .css({
        position: 'absolute',
        bottom: `${containerHeight - (top + height) + 7}px`,
        left: `${left + 5}px`,
        width: `${width - 10}px`,
      });
  }

  const header = $('#shopify-section-cad-header');

  if (!isMobile) {
    setTimeout(updateCoverPosition, 500);
    window.addEventListener("resize", updateCoverPosition)

    document.addEventListener("scroll", function (e) {
      const {top, bottom} = heroSwiper.el.getBoundingClientRect();
      if (
        (top < 0 && heroSwiper.activeIndex === 0) ||
        (bottom > $(window).height() && heroSwiper.activeIndex === heroSwiper.slides.length - 1 && heroNestedSwiper.activeIndex === heroNestedSwiper.slides.length - 1)
      ) {
        captureHero();
      }
    });

    let prevEvent = null;
    window.addEventListener("wheel", function (e) {
      if (!wheelCaptured) return;
      e.preventDefault();

      const slideChange =
        !heroSwiper.animating
        && !heroNestedSwiper.animating
        && (
          !prevEvent ||
          e.direction !== prevEvent.direction ||
          Math.abs(e.deltaY) > Math.abs(prevEvent.deltaY) ||
          e.timeStamp > prevEvent.timeStamp + 150
        );

      if (slideChange) {
        if (e.deltaY > 0) {
          if (heroSwiper.activeIndex === heroSwiper.slides.length - 1) {
            if (heroNestedSwiper.activeIndex === heroNestedSwiper.slides.length - 1) {
              releaseHero();
            } else {
              heroNestedSwiper.slideTo(heroNestedSwiper.activeIndex + 1)
            }

          } else {
            heroSwiper.slideTo(heroSwiper.activeIndex + 1);
            header.removeClass('fixed');
          }
        } else if (e.deltaY < 0) {
          if (heroSwiper.activeIndex === heroSwiper.slides.length - 1 && heroNestedSwiper.activeIndex > 0) {
            heroNestedSwiper.slideTo(heroNestedSwiper.activeIndex - 1)
          } else {
            if (heroSwiper.activeIndex === 0) {
              releaseHero();
            } else {
              heroSwiper.slideTo(heroSwiper.activeIndex - 1);
              header.addClass('fixed');
            }
          }
        }
      }

      prevEvent = e;
    }, {passive: false})
  } else {
    const slide13NestedContainer = $('.slide-nested-container[data-slide="12"]');
    const nestedSlides13 = $('.slide-nested-container[data-slide="12"] [data-slide] .swiper-slide');
    const mobileSlidesContainer = $('.mobile-slides');
    const mobileSlides = $('.mobile-slides > [data-slide]');
    const capsuleContainer = $('.mobile-slides .about-capsule-container')
    const windowHeight = $(window).height();
    const mobileSlidesWidth = mobileSlidesContainer.width();

    mobileSlidesContainer.css('top', -header.height() + 'px');
    const navbarSize = $('.mobile-slides .swiper-slide').height() - windowHeight;
    const mobileSlideContentMarginBottom = Math.max(navbarSize + 20, 50)
    $('.mobile-slides .box-image').css('margin-bottom', mobileSlideContentMarginBottom + 'px')
    $('.mobile-slides .slide-content > .slideFromToWrapper').css('margin-bottom', mobileSlideContentMarginBottom + 'px');
    mobileSlides.eq(2).find('.bottomText').css('margin-bottom', mobileSlideContentMarginBottom + 'px');
    mobileSlides.eq(5).find('.slideColumn:last-child').css('margin-bottom', mobileSlideContentMarginBottom + 'px');
    mobileSlides.eq(10).find('.slideColumn:last-child').css('margin-bottom', mobileSlideContentMarginBottom + 'px');
    $('.mobile-slides .box-cover').css('top', (mobileSlides.eq(9).position().top + mobileSlides.eq(9).find('.mobile-only img').offset().top - mobileSlides.eq(9).offset().top + mobileSlides.eq(9).find('.mobile-only img').height() - $('.mobile-slides .box-cover').width() / 3.67) + 'px')

    function slide1State() {
      const slide = mobileSlides.eq(1);
      return {
        width: 139,
        top: slide.position().top + 0.45 * slide.height(),
        left: mobileSlidesWidth / 2,
        step: capsules.CONCEPT_1,
        opacity: 0,
      };
    }

    function slide2State() {
      const slide = mobileSlides.eq(1);
      return {
        width: 139,
        top: slide.position().top + 0.45 * slide.height(),
        left: mobileSlidesWidth / 2,
        step: capsules.CONCEPT_1,
        opacity: 1,
      };
    }

    function slide3State() {
      const slide = mobileSlides.eq(2);
      const slideImage = slide.find('img');
      const capsuleWidth = 39;
      const capsuleHeight = capsuleWidth / 0.838;

      return {
        width: capsuleWidth,
        top: slide.position().top + (slideImage.offset().top - slide.offset().top) + (slideImage.height() / 2 - capsuleHeight / 2),
        left: mobileSlidesWidth / 2,
        step: capsules.CONCEPT_1,
        opacity: 1,
      };
    }

    function slide4State() {
      const slide = mobileSlides.eq(3);
      return {
        width: 118,
        top: slide.position().top + 0.5 * slide.height(),
        left: mobileSlidesWidth / 2,
        step: capsules.CONCEPT_1,
        opacity: 1,
      };
    }

    function slide5State() {
      const slide = mobileSlides.eq(4);
      const slideImage = slide.find('img');
      const capsuleWidth = slideImage.width() * 0.481;
      const capsuleHeight = capsuleWidth / 0.838;

      return {
        width: capsuleWidth,
        top: slide.position().top + (slideImage.offset().top - slide.offset().top) + (slideImage.height() / 2 - capsuleHeight / 2),
        left: mobileSlidesWidth / 2,
        step: capsules.CONCEPT_2,
        opacity: 1,
      };
    }

    /*
    function slide6State() {
      const slide = mobileSlides.eq(4);
      const slideImage = slide.find('.still-image');

      return {
        width: slideImage.width() * 0.6,
        top: slide.position().top + slideImage.position().top + 0.2 * slideImage.width() / 0.832,
        left: mobileSlidesWidth / 2,
        step: capsules.CONCEPT_2,
        opacity: 1,
      };
    }
    */

    function slide7State() {
      const slide = mobileSlides.eq(5);
      const slideImage = slide.find('img');
      const capsuleWidth = 118;
      const capsuleHeight = capsuleWidth / 0.838;

      return {
        width: capsuleWidth,
        top: slide.position().top + (slideImage.offset().top - slide.offset().top) + 0.5 * slideImage.height() - capsuleHeight / 2,
        left: mobileSlidesWidth / 2,
        step: capsules.PLASTIC,
        opacity: 1,
      };
    }

    function slide8State() {
      const slide = mobileSlides.eq(6);
      const capsuleWidth = 140;
      const capsuleHeight = capsuleWidth / 0.838;

      return {
        width: capsuleWidth,
        top: slide.position().top + 0.5 * slide.height() - capsuleHeight / 2,
        left: mobileSlidesWidth / 2,
        step: capsules.PLASTIC,
        opacity: 1,
      };
    }

    function slide9State() {
      const slide = mobileSlides.eq(7);
      return {
        width: 118,
        top: slide.position().top + 0.3 * slide.height(),
        left: mobileSlidesWidth / 2,
        step: capsules.BEADS,
        opacity: 1,
      };
    }

    function slide10State() {
      const slide = mobileSlides.eq(8);
      return {
        width: 118,
        top: slide.position().top + 0.3 * slide.height(),
        left: mobileSlidesWidth / 2,
        step: capsules.EXPLODED,
        opacity: 1,
      };
    }

    function slide11State() {
      const slide = mobileSlides.eq(9);
      const slideImage = slide.find('.mobile-only img');

      return {
        width: slideImage.width() / 3.06,
        top: slide.position().top + slideImage.offset().top - slide.offset().top + slideImage.height() - slideImage.width() / 3.09 / 0.8098 - 5,
        left: slideImage.width() / 2 - slideImage.width() * 0.003,
        step: capsules.BLUE,
        opacity: 1,
      };
    }

    const capsuleStates = [
      slide1State(),
      slide2State(),
      slide3State(),
      slide4State(),
      slide5State(),
      //slide6State(),
      slide7State(),
      slide8State(),
      slide9State(),
      slide10State(),
      slide11State(),
      slide11State()
    ];
    const easing = window.BezierEasing(.25,.1,.25,1);

    function updateNestedSlide13Position() {
      const { top, bottom, height } = slide13NestedContainer.get(0).getBoundingClientRect();
      if (bottom < windowHeight) {
        slide13NestedContainer.removeClass('top');
        slide13NestedContainer.removeClass('fixed');
        slide13NestedContainer.addClass('bottom');
      } else if (top > 0) {
        slide13NestedContainer.removeClass('bottom');
        slide13NestedContainer.removeClass('fixed');
        slide13NestedContainer.addClass('top');
      } else {
        slide13NestedContainer.removeClass('bottom');
        slide13NestedContainer.removeClass('top');
        slide13NestedContainer.addClass('fixed');

        const totalProgress = -top / (height - windowHeight - navbarSize);
        const currentSlideIdx = Math.floor(totalProgress / (1 / (nestedSlides13.length - 1)));
        const progress = totalProgress / (1 / (nestedSlides13.length - 1)) - currentSlideIdx;

        const currentSlide = nestedSlides13.eq(currentSlideIdx);
        const nextSlide = nestedSlides13.eq(currentSlideIdx + 1);

        nestedSlides13.css('opacity', 0);
        currentSlide.css('opacity', easing(1 - progress))
        nextSlide.css('opacity', easing(progress))

        if (!currentSlide.is('.hasTo') && nextSlide.is('.hasTo')) {
          nextSlide.find('p:nth-child(n+3)').css('top', (easing(1 - progress) * 100) + 'px')
        } else {
          currentSlide.find('p:nth-child(2n)').css('left', easing(progress) * -50 + '%')
          nextSlide.find('p:nth-child(2n)').css('left', easing(1 - progress) * 50 + '%')
        }
      }
    }

    function updateCapsulePosition() {
      let currentSlideIdx = -1;
      let currentSlide;
      for (let i = mobileSlides.length - 1; i >= 0; --i) {
        const slide = mobileSlides.get(i);
        if (slide.getBoundingClientRect().top <= 1) {
          currentSlideIdx = i;
          currentSlide = slide;
          break;
        }
      }

      if (currentSlideIdx === -1) return;
      const currentState = capsuleStates[currentSlideIdx];
      const nextState = capsuleStates[currentSlideIdx + 1];
      if (!nextState) return;


      if (!$(currentSlide).is('.fixed')) {
        let measured;
        let additionalHeight = 0;
        if ($(currentSlide).is('.slide-nested-container')) {
          measured = $(currentSlide).find('[data-slide]').get(0)
          additionalHeight = currentSlide.getBoundingClientRect().top;
        } else {
          measured = currentSlide;
        }
        const { top, height } = measured.getBoundingClientRect();
        const progress = -top / height;

        capsuleContainer.css('width', (currentState.width + (nextState.width - currentState.width) * progress) + 'px');
        capsuleContainer.css('top', (currentState.top - additionalHeight + (nextState.top - currentState.top + additionalHeight) * progress) + 'px');
        capsuleContainer.css('left', (currentState.left + (nextState.left - currentState.left) * progress) + 'px');

        if (currentState.step !== nextState.step || currentState.opacity !== nextState.opacity) {
          $('.about-capsule-container img').css('opacity', 0)
          $(getCapsuleByStep(currentState.step)).css('opacity', currentState.opacity === 0 ? progress : 1 - progress);
          $(getCapsuleByStep(nextState.step)).css('opacity', progress);
        }
      }
    }


    let currentTouch;
    let currentSlide = 0;
    let currentNested13Slide = 0;
    let animationInProgress = false;
    let captureTouch = false;

    $(window).on('scroll', function () {
      const { bottom, top } = mobileSlidesContainer.get(0).getBoundingClientRect();
      if (currentSlide === 0 && top < 1) {
        if (!captureTouch) window.scrollTo({ top: mobileSlidesContainer.offset().top });
        captureTouch = true;
      } else if (bottom >= windowHeight && currentSlide === mobileSlides.length - 1 && currentNested13Slide === nestedSlides13.length - 1) {
        if (!captureTouch) window.scrollTo({ top: mobileSlidesContainer.offset().top + mobileSlidesContainer.height() - windowHeight });
        captureTouch = true;
      } else if (bottom < windowHeight || top >= 0) {
        captureTouch = false;
      }

      updateNestedSlide13Position();

      if (!capsuleContainer.is('.fixed')) updateCapsulePosition();
    });

    capsuleContainer.css('width', capsuleStates[0].width + 'px');
    capsuleContainer.css('top', capsuleStates[0].top + 'px');
    capsuleContainer.css('left', capsuleStates[0].left + 'px');

    window.addEventListener("touchstart", function (e) {
      currentTouch = e.touches[0];
    }, { passive: false });

    window.addEventListener("touchmove", function (e) {
      if (captureTouch) e.preventDefault();
      else {
        const { top } = mobileSlidesContainer.get(0).getBoundingClientRect();
        if (currentSlide === 0 && top < 1) captureTouch = true;
      }
    }, { passive: false });

    window.addEventListener("touchend", function (e) {
      if (!captureTouch) return;
      const touch = e.changedTouches[0];
      if (animationInProgress || !currentTouch || !touch || touch.identifier !== currentTouch.identifier) return;
      const delta = currentTouch.screenY - touch.screenY;
      if (delta > 10) {
        animationInProgress = true;
        if (currentSlide === 11 && currentNested13Slide < nestedSlides13.length - 1) {
          currentNested13Slide += 1;
          const scrollTop = $(slide13NestedContainer).offset().top + currentNested13Slide * $(slide13NestedContainer).height() / nestedSlides13.length
          $('html, body').animate({ scrollTop: scrollTop }, animationSpeed, 'swing', () => {
            animationInProgress = false;
          });
        } else if (currentSlide === 11) {
          const scrollTop = $(slide13NestedContainer).offset().top + $(slide13NestedContainer).height();
          $('html, body').animate({ scrollTop: scrollTop }, animationSpeed, 'swing', () => {
            animationInProgress = false;
          });
        } else {
          $('html, body').animate({ scrollTop: mobileSlides.eq(currentSlide + 1).offset().top }, animationSpeed, 'swing', () => {
            animationInProgress = false;
          });
          currentSlide += 1;
        }
      }

      if (delta < -10) {
        animationInProgress = true;
        if (currentSlide === 11 && currentNested13Slide > 0) {
          currentNested13Slide -= 1;
          const scrollTop = $(slide13NestedContainer).offset().top + currentNested13Slide * $(slide13NestedContainer).height() / nestedSlides13.length
          $('html, body').animate({ scrollTop: scrollTop }, animationSpeed, 'swing', () => {
            animationInProgress = false;
          });
        } else if (currentSlide > 0) {
          $('html, body').animate({scrollTop: mobileSlides.eq(currentSlide - 1).offset().top}, animationSpeed, 'swing', () => {
            animationInProgress = false;
          });
          currentSlide -= 1;
        } else if (currentSlide === 0) {
          $('html, body').animate({ scrollTop:$(document).scrollTop() - 300 }, 500, 'swing', () => {
            animationInProgress = false;
          });
        }
      }

    }, { passive: false });
  }
});
